var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "dropdown-menu"]
var hoisted2 = ["class", "dropdown-header"]
var hoisted3 = ["class", "fa fa-pencil"]
var hoisted4 = ["class", "divider"]
var hoisted5 = ["class", "fa fa-scissors"]
var hoisted6 = ["class", "fa fa-copy"]
var hoisted7 = ["class", "fa fa-paste"]
var hoisted8 = ["class", "divider"]
var hoisted9 = ["class", "fa fa-file"]
var hoisted10 = ["class", "fa fa-folder"]
var hoisted11 = ["class", "divider"]
var hoisted12 = ["class", "fa fa-trash"]
var __target

module.exports = function fileMenu (model) {
  var node = model.node
      var file = model.file
  if (file) {
    elementOpen("ul", "db4adf63-c472-4db0-aef3-c5996c6977d6", hoisted1, "style", { top: model.y, left: model.x })
      elementOpen("li", "header", hoisted2)
        text("" + (file.name) + "")
      elementClose("li")
      elementOpen("li", "rename")
        elementOpen("a", null, null, "onclick", function ($event) {
          var $element = this;
        model.rename(file)})
          elementOpen("i", "c37aaaee-9fbd-4589-bcdc-6b99ca83177f", hoisted3)
          elementClose("i")
          text(" Rename")
        elementClose("a")
      elementClose("li")
      elementOpen("li", "divider-1", hoisted4)
      elementClose("li")
      elementOpen("li", "cut")
        elementOpen("a", null, null, "onclick", function ($event) {
          var $element = this;
        model.setPasteBuffer(file, 'cut')})
          elementOpen("i", "c79db774-cbc8-4b42-8169-b6e60d546a8f", hoisted5)
          elementClose("i")
          text(" Cut")
        elementClose("a")
      elementClose("li")
      elementOpen("li", "copy")
        elementOpen("a", null, null, "onclick", function ($event) {
          var $element = this;
        model.setPasteBuffer(file, 'copy')})
          elementOpen("i", "1c15f321-ab26-4239-b08f-a8ef718245ae", hoisted6)
          elementClose("i")
          text(" Copy")
        elementClose("a")
      elementClose("li")
      if (model.showPaste(file)) {
        elementOpen("li", "paste")
          elementOpen("a", null, null, "onclick", function ($event) {
            var $element = this;
          model.paste(file)})
            elementOpen("i", "0037e47e-eef8-4c43-b19b-6fda2a4325cb", hoisted7)
            elementClose("i")
            text(" Paste")
          elementClose("a")
        elementClose("li")
      }
      elementOpen("li", "divider-2", hoisted8)
      elementClose("li")
      elementOpen("li", "mkfile")
        elementOpen("a", null, null, "onclick", function ($event) {
          var $element = this;
        model.mkfile(node)})
          elementOpen("i", "14419c42-cb6a-4144-b016-f870c6b15f0d", hoisted9)
          elementClose("i")
          text(" Add new file")
        elementClose("a")
      elementClose("li")
      elementOpen("li", "mkdir")
        elementOpen("a", null, null, "onclick", function ($event) {
          var $element = this;
        model.mkdir(node)})
          elementOpen("i", "bea9abbe-6474-4593-b6e9-4eb432b8fe27", hoisted10)
          elementClose("i")
          text(" Add new folder")
        elementClose("a")
      elementClose("li")
      elementOpen("li", "divider-3", hoisted11)
      elementClose("li")
      elementOpen("li", "delete")
        elementOpen("a", null, null, "onclick", function ($event) {
          var $element = this;
        model.remove(file)})
          elementOpen("i", "4a572103-766b-4642-b2a9-11c462ba6faf", hoisted12)
          elementClose("i")
          text(" Delete")
        elementClose("a")
      elementClose("li")
    elementClose("ul")
  }
}
